var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetaNextPage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61719 8.8606C1.61719 9.15825 1.85847 9.39953 2.15611 9.39953L15.0903 9.39953C15.388 9.39953 15.6292 9.15825 15.6292 8.86061C15.6292 8.56297 15.388 8.32168 15.0903 8.32168L2.15611 8.32168C1.85847 8.32168 1.61719 8.56296 1.61719 8.8606Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3979 13.5531C10.6083 13.7636 10.9496 13.7636 11.16 13.5531L15.4714 9.24169C15.6819 9.03122 15.6819 8.68999 15.4714 8.47953L11.16 4.16812C10.9496 3.95766 10.6083 3.95766 10.3979 4.16812C10.1874 4.37859 10.1874 4.71981 10.3979 4.93028L14.3282 8.86061L10.3979 12.7909C10.1874 13.0014 10.1874 13.3426 10.3979 13.5531Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.61719 8.8606C1.61719 9.15825 1.85847 9.39953 2.15611 9.39953L15.0903 9.39953C15.388 9.39953 15.6292 9.15825 15.6292 8.86061C15.6292 8.56297 15.388 8.32168 15.0903 8.32168L2.15611 8.32168C1.85847 8.32168 1.61719 8.56296 1.61719 8.8606Z",
    stroke: "white",
    strokeWidth: 0.739098,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3979 13.5531C10.6083 13.7636 10.9496 13.7636 11.16 13.5531L15.4714 9.24169C15.6819 9.03122 15.6819 8.68999 15.4714 8.47953L11.16 4.16812C10.9496 3.95766 10.6083 3.95766 10.3979 4.16812C10.1874 4.37859 10.1874 4.71981 10.3979 4.93028L14.3282 8.86061L10.3979 12.7909C10.1874 13.0014 10.1874 13.3426 10.3979 13.5531Z",
    stroke: "white",
    strokeWidth: 0.739098,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetaNextPage);
export default __webpack_public_path__ + "static/media/seta-next-page.9934115f2e0d7c0426b0e3a7d0905585.svg";
export { ForwardRef as ReactComponent };